export type PasswordRuleKey =
	| "length"
	| "upper"
	| "lower"
	| "number"
	| "special";

export type PasswordRule = {
	key: PasswordRuleKey;
	listLabel: string; // checklist wording
	inlineLabel: string; // sentence wording
	test: (pwd: string) => boolean;
};

// Mirrors backend validateHybridPasswordComplexity — keep in sync
export const PASSWORD_RULES: PasswordRule[] = [
	{
		key: "length",
		listLabel: "At least 8 characters",
		inlineLabel: "Min. 8 characters",
		test: (p) => p.length >= 8,
	},
	{
		key: "upper",
		listLabel: "At least 1 uppercase letter",
		inlineLabel: "uppercase",
		test: (p) => /[A-Z]/.test(p),
	},
	{
		key: "lower",
		listLabel: "At least 1 lowercase letter",
		inlineLabel: "lowercase",
		test: (p) => /[a-z]/.test(p),
	},
	{
		key: "number",
		listLabel: "At least 1 number",
		inlineLabel: "number",
		test: (p) => /[0-9]/.test(p),
	},
	{
		key: "special",
		listLabel: "At least 1 special character",
		inlineLabel: "special character",
		test: (p) => /[^A-Za-z0-9]/.test(p),
	},
];

export const isPasswordValid = (pwd: string): boolean =>
	PASSWORD_RULES.every((r) => r.test(pwd));
